import FormattedMessage from 'I18n/components/FormattedMessage';
import { H4 } from 'UIComponents/elements/headings';
import UIStatusDot from 'UIComponents/tag/UIStatusDot';
import { ApprovalNotRequestedI18nMessage } from '../i18n/ApprovalNotRequestedI18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ApprovalNotRequested(props) {
  const {
    approvalType,
    approvalAction
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    className: "p-all-5",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "display-flex align-center m-bottom-3",
      children: [/*#__PURE__*/_jsx(UIStatusDot, {
        use: "disabled"
      }), /*#__PURE__*/_jsx(H4, {
        className: "m-bottom-0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalNotRequested.header"
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(ApprovalNotRequestedI18nMessage, {
        approvalType: approvalType,
        approvalAction: approvalAction
      })
    })]
  });
}
export default ApprovalNotRequested;